/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
// Material UI
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
// Custom Components
import SectionPageListItem from './SectionPageListItem';

function SectionPageList(props) {
  const { section } = props;

  if (!section?.pages) {
    return null;
  }

  if (section.pages.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center h-full mt-72">
        <Typography color="text.secondary" variant="p">
          There are no pages!
        </Typography>
      </div>
    );
  }

  return (
    <List className="w-full m-0 p-0">
      {section.pages.map((page) => (
        <SectionPageListItem
          key={page.id}
          page={page}
          commentCount={
            (page.comments || []).filter(
              (comment) =>
                !['alpha_internal', 'beta_internal', 'final_internal'].includes(
                  comment.review_cycle
                )
            ).length
          }
        />
      ))}
    </List>
  );
}

export default SectionPageList;
